import React from 'react';
import PropTypes from 'prop-types';
import ImageViewer from '@/components/atoms/ImageViewer';
import {COLOR_CODE} from '@/utils/constants/colors';
import {CSS_CLASSES, IMAGE_CONFIG} from '../ReviewConstants';

/**
 * RewardImages component - Displays product images with position labels
 * @param {Object} productData - Product display data containing images
 * @param {Boolean} hidePositionLabel - If true, hides the position label (for single image reward types)
 * @returns {JSX.Element} The rendered RewardImages component
 */
const RewardImages = ({productData, hidePositionLabel = false}) => {
  const images = productData?.images;

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className={CSS_CLASSES.COMMON.GRID_3_COLS}>
      {images.map((image) => {
        const imageUrl = image?.url;
        const position = image.position;
        const uniqueKey = `custom-${imageUrl}-${position}`;

        return imageUrl ? (
          <div key={uniqueKey} className={CSS_CLASSES.COMMON.FLEX_COL_GAP}>
            {!hidePositionLabel && (
              <span
                className={`key ${CSS_CLASSES.COMMON.TEXT_SMALL}`}
                style={{color: COLOR_CODE._EFEFEF}}>
                {IMAGE_CONFIG.POSITION.TEXT_PREFIX}
                {position}
              </span>
            )}
            <div>
              <ImageViewer url={imageUrl} />
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

RewardImages.propTypes = {
  productData: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        position: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    )
  }),
  hidePositionLabel: PropTypes.bool
};

RewardImages.defaultProps = {
  hidePositionLabel: false
};

export default RewardImages;
